import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./App.css";
import CitySelector from './CitySelector';
import CityStreetSelector from "./CityStreetSelector";
import Legend from './Legend';
import CalendarTile from "./CalendarTile";
import "./MonthCalendar.css";

// import LogosAndMessages from './LogosAndMessages';


const months = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
];

function App() {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [collectionTypes, setCollectionTypes] = useState([]);
  const [collectionDates, setCollectionDates] = useState([]);
  const [selectedType, setSelectedType] = useState("toustypes");
  const [commune , getCommune ] = useState("Guingamp [22070]")







  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  return (
    <div className="App">
<h1 className="title">Mon calendrier de collecte</h1>

      {/* <LogosAndMessages commune={commune} /> */}

      <CityStreetSelector selectedYear={selectedYear}
        handleYearChange={handleYearChange}
        setCollectionTypes={setCollectionTypes}
        setCollectionDates={setCollectionDates}
        collectionTypes={collectionTypes}
        selectedType={selectedType}
        setSelectedType={setSelectedType}

      />

      <Legend collectionTypes={collectionTypes} />



      <div className="calendar-grid">
        {months.map((month, index) => (
          <div key={index} className="calendar-container">
            <h2>{month}</h2>
            <Calendar
              locale="fr"
              activeStartDate={new Date(selectedYear, index)}
              className="month-calendar"
              navigation={false}
              next2Label={null}
              prev2Label={null}
              showNavigation={false}
              // tileDisabled={({ date, view }) =>
              //   view === "month" && date.getMonth() !== index ? "outside-month" : ""
              // }
              tileDisabled={({ date, view }) =>
                view === "month" && date.getMonth() !== index
              }
           

              tileContent={({ date, view }) => {
                if (view === "month") {
                  return (
                    <CalendarTile
                      date={date}
                      collectionDates={collectionDates}
                      monthIndex={index}
                      selectedType={selectedType}
                    />
                  );
                }
                return null;
              }}


            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default App;
